class Sofatutor.Classes.Countdown
  constructor: (selector) ->
    @el                   = document.querySelector(selector)
    @circumferenceLength  = @el.dataset.circunferenceLength
    @timeLimit            = @el.dataset.secondsLimit
    @timeLeft             = @timeLimit
    @timerInterval        = null

    @addEventListener     = @el.addEventListener.bind(@el)
    @removeEventListener  = @el.removeEventListener.bind(@el)

  start: =>
    timePassed = 0

    @timerInterval = setInterval( =>
      @timeLeft   = @timeLimit - timePassed
      timePassed  = timePassed += 1

      @drawElapsedCircle(timePassed)
      @updateLabel()

      @end() if @timeLeft == 0
    , 1000)

  stop: =>
    clearInterval(@timerInterval)
    @el.dispatchEvent(new CustomEvent('countdownStopped'))

  end: =>
    clearInterval(@timerInterval)
    @el.dispatchEvent(new CustomEvent('countdownEnded'))

  drawElapsedCircle: (currentTime) ->
    timeFraction  = currentTime / @timeLimit
    dashoffset    = timeFraction * @circumferenceLength

    @el.querySelector('.countdown__circle-elapsed').style.strokeDasharray = "#{dashoffset.toFixed(0)} #{@circumferenceLength}"

  updateLabel: =>
    @el.querySelector('.countdown__time-label').textContent = I18n.t('txt.gamification.countdown.seconds', count: @timeLeft)
